<template>
  <div
    v-if="orderRoomErrors.hasErrors"
    class="section"
  >
    <div class="container max-width-mobile">
      <div
        v-for="error in orderRoomErrors.otherErrors"
        :key="error.code"
        class="message message--danger"
      >
        <div class="layout layout--icon">
          <span class="icon fa-exclamation-circle" />
          <p>{{ error.message }}</p>
        </div>
      </div>

      <div
        v-for="error in orderRoomErrors.retryCaptureErrors"
        :key="error.code"
        class="message message--danger"
      >
        <div class="layout layout--icon">
          <span class="icon fa-exclamation-circle" />
          <p>{{ error.message }}</p>
        </div>
      </div>

      <button
        v-if="orderRoomErrors.retryCaptureErrors.length > 0 && orderRoomErrors.retryCaptureErrors[0].websocketUserId === orderRoom.you.id"
        class="button button--large button--primary"
        :class="{
          'button--loading': isRetryingCapture
        }"
        :disabled="isRetryingCapture"
        type="button"
        @click="retryPaymentCapture"
      >
        Retry
      </button>
    </div>
  </div>
</template>



<script>
  import errorHandlers from '@/services/error-handlers';
  import { mapGetters } from 'vuex';



  export default {
    name: 'OrderRoomErrors',

    data() {
      return {
        isRetryingCapture: false
      };
    },

    computed: {
      ...mapGetters('socket', ['orderRoom', 'orderRoomErrors'])
    },

    methods: {
      async retryPaymentCapture() {
        try {
          this.isRetryingCapture = true;

          await this.$store.dispatch('socket/retryPaymentCapture');

          if (this.$route.name !== 'payAtTableReceipt') {
            this.$router.replace({
              name: 'payAtTableReceipt',
              params: {
                merchantId: this.$route.params.merchantId,
                receiptToken: this.orderRoom.you.receiptToken
              }
            });
          }
        }

        catch (error) {
          errorHandlers.silent(error);
        }

        finally {
          this.isRetryingCapture = false;
        }
      }
    }
  };
</script>
